// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__ui-tab-bar-U4mvWQ {
  justify-content: space-between;
  width: 100%;
  display: flex;
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__ui-tab-bar-U4mvWQ .semi-tabs {
  width: 100%;
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__ui-tab-bar-U4mvWQ .semi-tabs-bar {
  flex-wrap: nowrap;
  display: flex;
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__ui-tab-bar-U4mvWQ .semi-tabs-bar svg {
  width: 20px;
  height: 20px;
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__ui-tab-bar-U4mvWQ .semi-tabs-content {
  display: none;
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__ui-tab-bar-U4mvWQ .semi-tabs-tab:last-child:before {
  content: "";
  background-color: var(--light-usage-border-color-border, rgba(28, 29, 35, .12));
  width: 1px;
  height: 16px;
  position: absolute;
  top: 6px;
  left: -4px;
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__ui-tab-bar-U4mvWQ .semi-tabs-tab-single.semi-tabs-tab {
  color: var(--light-usage-text-color-text-2, rgba(29, 28, 35, .45));
  font-weight: 600;
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__ui-tab-bar-U4mvWQ .semi-tabs-tab-single.semi-tabs-tab .semi-icon:not(:-webkit-any(.semi-icon-checkbox_tick, .semi-icon-radio, .semi-icon-checkbox_indeterminate)) {
  color: var(--light-usage-text-color-text-2, rgba(29, 28, 35, .45));
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__ui-tab-bar-U4mvWQ .semi-tabs-tab-single.semi-tabs-tab .semi-icon:not(:-moz-any(.semi-icon-checkbox_tick, .semi-icon-radio, .semi-icon-checkbox_indeterminate)) {
  color: var(--light-usage-text-color-text-2, rgba(29, 28, 35, .45));
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__ui-tab-bar-U4mvWQ .semi-tabs-tab-single.semi-tabs-tab .semi-icon:not(:is(.semi-icon-checkbox_tick, .semi-icon-radio, .semi-icon-checkbox_indeterminate)) {
  color: var(--light-usage-text-color-text-2, rgba(29, 28, 35, .45));
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__ui-tab-bar-U4mvWQ .semi-tabs-tab-button.semi-tabs-tab:hover {
  background-color: rgba(0, 0, 0, 0);
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__ui-tab-bar-U4mvWQ .semi-tabs-tab-single.semi-tabs-tab:hover {
  color: var(--light-usage-text-color-text-1, rgba(29, 28, 35, .8));
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__ui-tab-bar-U4mvWQ .semi-tabs-tab-single.semi-tabs-tab:hover .semi-icon:not(:-webkit-any(.semi-icon-checkbox_tick, .semi-icon-radio, .semi-icon-checkbox_indeterminate)) {
  color: var(--light-usage-text-color-text-1, rgba(29, 28, 35, .8));
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__ui-tab-bar-U4mvWQ .semi-tabs-tab-single.semi-tabs-tab:hover .semi-icon:not(:-moz-any(.semi-icon-checkbox_tick, .semi-icon-radio, .semi-icon-checkbox_indeterminate)) {
  color: var(--light-usage-text-color-text-1, rgba(29, 28, 35, .8));
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__ui-tab-bar-U4mvWQ .semi-tabs-tab-single.semi-tabs-tab:hover .semi-icon:not(:is(.semi-icon-checkbox_tick, .semi-icon-radio, .semi-icon-checkbox_indeterminate)) {
  color: var(--light-usage-text-color-text-1, rgba(29, 28, 35, .8));
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__ui-tab-bar-U4mvWQ .semi-tabs-tab-button.semi-tabs-tab-active {
  color: var(--light-usage-text-color-text-0, #1d1c23);
  background-color: rgba(0, 0, 0, 0);
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__ui-tab-bar-U4mvWQ .semi-tabs-tab-button.semi-tabs-tab-active:hover {
  color: var(--light-usage-text-color-text-0, #1d1c23);
  background-color: rgba(0, 0, 0, 0);
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__ui-tab-bar-U4mvWQ .semi-tabs-tab-single.semi-tabs-tab-active .semi-icon:not(:-webkit-any(.semi-icon-checkbox_tick, .semi-icon-radio, .semi-icon-checkbox_indeterminate)) {
  color: var(--light-usage-text-color-text-0, #1d1c23);
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__ui-tab-bar-U4mvWQ .semi-tabs-tab-single.semi-tabs-tab-active .semi-icon:not(:-moz-any(.semi-icon-checkbox_tick, .semi-icon-radio, .semi-icon-checkbox_indeterminate)) {
  color: var(--light-usage-text-color-text-0, #1d1c23);
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__ui-tab-bar-U4mvWQ .semi-tabs-tab-single.semi-tabs-tab-active .semi-icon:not(:is(.semi-icon-checkbox_tick, .semi-icon-radio, .semi-icon-checkbox_indeterminate)) {
  color: var(--light-usage-text-color-text-0, #1d1c23);
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__ui-tab-bar-U4mvWQ .semi-tabs-tab-single.semi-tabs-tab-active:hover .semi-icon:not(:-webkit-any(.semi-icon-checkbox_tick, .semi-icon-radio, .semi-icon-checkbox_indeterminate)) {
  color: var(--light-usage-text-color-text-0, #1d1c23);
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__ui-tab-bar-U4mvWQ .semi-tabs-tab-single.semi-tabs-tab-active:hover .semi-icon:not(:-moz-any(.semi-icon-checkbox_tick, .semi-icon-radio, .semi-icon-checkbox_indeterminate)) {
  color: var(--light-usage-text-color-text-0, #1d1c23);
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__ui-tab-bar-U4mvWQ .semi-tabs-tab-single.semi-tabs-tab-active:hover .semi-icon:not(:is(.semi-icon-checkbox_tick, .semi-icon-radio, .semi-icon-checkbox_indeterminate)) {
  color: var(--light-usage-text-color-text-0, #1d1c23);
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__tab-bar-blue-pJSHfb .semi-tabs-tab-button.semi-tabs-tab-active {
  color: var(--light-usage-primary-color-primary, #4d53e8);
  background-color: rgba(0, 0, 0, 0);
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__tab-bar-blue-pJSHfb .semi-tabs-tab-button.semi-tabs-tab-active:hover {
  color: var(--light-usage-primary-color-primary, #4d53e8);
  background-color: rgba(0, 0, 0, 0);
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__tab-bar-blue-pJSHfb .semi-tabs-tab-single.semi-tabs-tab-active .semi-icon:not(:-webkit-any(.semi-icon-checkbox_tick, .semi-icon-radio, .semi-icon-checkbox_indeterminate)) {
  color: var(--light-usage-primary-color-primary, #4d53e8);
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__tab-bar-blue-pJSHfb .semi-tabs-tab-single.semi-tabs-tab-active .semi-icon:not(:-moz-any(.semi-icon-checkbox_tick, .semi-icon-radio, .semi-icon-checkbox_indeterminate)) {
  color: var(--light-usage-primary-color-primary, #4d53e8);
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__tab-bar-blue-pJSHfb .semi-tabs-tab-single.semi-tabs-tab-active .semi-icon:not(:is(.semi-icon-checkbox_tick, .semi-icon-radio, .semi-icon-checkbox_indeterminate)) {
  color: var(--light-usage-primary-color-primary, #4d53e8);
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__tab-bar-blue-pJSHfb .semi-tabs-tab-single.semi-tabs-tab-active:hover .semi-icon:not(:-webkit-any(.semi-icon-checkbox_tick, .semi-icon-radio, .semi-icon-checkbox_indeterminate)) {
  color: var(--light-usage-primary-color-primary, #4d53e8);
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__tab-bar-blue-pJSHfb .semi-tabs-tab-single.semi-tabs-tab-active:hover .semi-icon:not(:-moz-any(.semi-icon-checkbox_tick, .semi-icon-radio, .semi-icon-checkbox_indeterminate)) {
  color: var(--light-usage-primary-color-primary, #4d53e8);
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__tab-bar-blue-pJSHfb .semi-tabs-tab-single.semi-tabs-tab-active:hover .semi-icon:not(:is(.semi-icon-checkbox_tick, .semi-icon-radio, .semi-icon-checkbox_indeterminate)) {
  color: var(--light-usage-primary-color-primary, #4d53e8);
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__header-Bm5xex {
  justify-content: space-between;
  align-items: flex-start;
  display: flex;
}

.\\------packages-components-bot-semi-src-components-ui-tab-bar-index-module__tool-bar-sOQH9J {
  align-items: center;
  display: flex;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-tab-bar": `------packages-components-bot-semi-src-components-ui-tab-bar-index-module__ui-tab-bar-U4mvWQ`,
	"uiTabBar": `------packages-components-bot-semi-src-components-ui-tab-bar-index-module__ui-tab-bar-U4mvWQ`,
	"tab-bar-blue": `------packages-components-bot-semi-src-components-ui-tab-bar-index-module__tab-bar-blue-pJSHfb`,
	"tabBarBlue": `------packages-components-bot-semi-src-components-ui-tab-bar-index-module__tab-bar-blue-pJSHfb`,
	"header": `------packages-components-bot-semi-src-components-ui-tab-bar-index-module__header-Bm5xex`,
	"tool-bar": `------packages-components-bot-semi-src-components-ui-tab-bar-index-module__tool-bar-sOQH9J`,
	"toolBar": `------packages-components-bot-semi-src-components-ui-tab-bar-index-module__tool-bar-sOQH9J`
};
export default ___CSS_LOADER_EXPORT___;
